import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDown, ChevronUp, FileText } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const [isLessonsOpen, setIsLessonsOpen] = useState(false);
  const location = useLocation();
  const policyMenuRef = useRef<HTMLDivElement>(null);
  const lessonsMenuRef = useRef<HTMLDivElement>(null);
  // Updated order of navigation links
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Tips',
    path: '/tips'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Blogs',
    path: '/blogs',
    icon: <FileText size={16} className="mr-1" data-id="element-235" data-mp="1pykr8bm84m58" />
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Contact Us',
    path: '/contact'
  }];
  const lessonLinks = [{
    name: 'Standard Lessons',
    path: '/standard-lessons'
  }, {
    name: 'Intensive Lessons',
    path: '/intensive-lessons'
  }, {
    name: 'Additional Lessons',
    path: '/additional-lessons'
  }];
  const policyLinks = [{
    name: 'Terms & Conditions',
    path: '/terms'
  }, {
    name: 'Cancellation, Health & Safety Policy',
    path: '/cancellation'
  }, {
    name: 'Privacy & Cookie Policy',
    path: '/privacy'
  }];
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const togglePoliciesMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsPoliciesOpen(!isPoliciesOpen);
    // Close other dropdown when opening this one
    if (!isPoliciesOpen) {
      setIsLessonsOpen(false);
    }
  };
  const toggleLessonsMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsLessonsOpen(!isLessonsOpen);
    // Close other dropdown when opening this one
    if (!isLessonsOpen) {
      setIsPoliciesOpen(false);
    }
  };
  // Close the dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (policyMenuRef.current && !policyMenuRef.current.contains(event.target as Node)) {
        setIsPoliciesOpen(false);
      }
      if (lessonsMenuRef.current && !lessonsMenuRef.current.contains(event.target as Node)) {
        setIsLessonsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Close the dropdowns when changing routes
  useEffect(() => {
    setIsPoliciesOpen(false);
    setIsLessonsOpen(false);
  }, [location.pathname]);
  return <nav className="bg-white shadow-md w-full" data-id="element-236" data-mp="7kcgxlb2wdf7">
      <div className="container mx-auto px-4" data-id="element-237" data-mp="7j1djmljp7om">
        <div className="flex justify-between items-center py-4" data-id="element-238" data-mp="2l9pj3o0u5pp">
          {/* Logo and School Name */}
          <Link to="/" className="flex items-center" data-id="element-239" data-mp="a4sgpx7f559d">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uQmtuFR4FdAFx95dEcdiJJ/Favicon.png" alt="Northampton Driving School Logo" className="h-14 mr-2" data-id="element-240" data-mp="a37k821jnc8v" />
            <h1 className="text-2xl font-bold" data-id="element-241" data-mp="166vfuakbc4w">
              <span className="text-burgundy-600" data-id="element-242" data-mp="54xpfsjqedns">N</span>orthampton{' '}
              <span className="text-burgundy-600" data-id="element-243" data-mp="svjvjea6dnv5">D</span>riving{' '}
              <span className="text-burgundy-600" data-id="element-244" data-mp="sxd2kuopaa3o">S</span>chool
            </h1>
          </Link>
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-1" data-id="element-245" data-mp="k383jnzexsd2">
            <Link key="/" to="/" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-246" data-mp="k2q0a7ec2dvn">
              Home
            </Link>
            {/* Our Lessons Dropdown - Moved to appear after Home */}
            <div className="relative" ref={lessonsMenuRef} data-id="element-247" data-mp="3p2qevsahcrlg">
              <button onClick={toggleLessonsMenu} className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${lessonLinks.some(link => location.pathname === link.path) ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-248" data-mp="3k2b0cxegpe1w">
                Our Lessons
                {isLessonsOpen ? <ChevronUp size={16} className="ml-1" data-id="element-249" data-mp="6nftgy8q169h" /> : <ChevronDown size={16} className="ml-1" data-id="element-250" data-mp="1x7o8sq2w1rz" />}
              </button>
              {/* Dropdown Menu */}
              {isLessonsOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200 overflow-hidden" data-id="element-251" data-mp="3tyxk1iv1xz2c">
                  <div className="py-1" data-id="element-252" data-mp="pn21vci81uda">
                    {lessonLinks.map(link => <Link key={link.path} to={link.path} className={`block px-4 py-2 text-sm transition-colors ${location.pathname === link.path ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsLessonsOpen(false)} data-id="element-253" data-mp="289tj4wxltkqu">
                        {link.name}
                      </Link>)}
                  </div>
                </div>}
            </div>
            {/* Total Drive App link - Moved to appear after Our Lessons */}
            <Link to="/total-drive" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/total-drive' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-254" data-mp="30zim3ftvjuv3">
              Total Drive App
            </Link>
            {/* Tips link */}
            <Link to="/tips" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/tips' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-255" data-mp="1evqxhj9dgsqw">
              Tips
            </Link>
            {/* FAQ link */}
            <Link to="/faq" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/faq' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-256" data-mp="1jtsoqrgybydg">
              FAQ
            </Link>
            {/* Blogs link - NEW */}
            <Link to="/blogs" className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/blog') ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-257" data-mp="27ibxt97tsf6l">
              <FileText size={16} className="mr-1" data-id="element-258" data-mp="89524uhc4t3n" />
              Blogs
            </Link>
            {/* About Us link */}
            <Link to="/about" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/about' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-259" data-mp="2otqy08uukp99">
              About Us
            </Link>
            {/* Contact Us link */}
            <Link to="/contact" className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${location.pathname === '/contact' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-260" data-mp="2134n89tgkqvk">
              Contact Us
            </Link>
            {/* Our Policies Dropdown - Moved to appear at the end */}
            <div className="relative" ref={policyMenuRef} data-id="element-261" data-mp="3ljri3uk9uhk8">
              <button onClick={togglePoliciesMenu} className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${policyLinks.some(link => location.pathname === link.path) ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-262" data-mp="3li6pwblfjapj">
                Our Policies
                {isPoliciesOpen ? <ChevronUp size={16} className="ml-1" data-id="element-263" data-mp="1zkunkzptaf34" /> : <ChevronDown size={16} className="ml-1" data-id="element-264" data-mp="1ziqmepjaru6j" />}
              </button>
              {/* Dropdown Menu */}
              {isPoliciesOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200 overflow-hidden" data-id="element-265" data-mp="1qjd91ls1ylgj">
                  <div className="py-1" data-id="element-266" data-mp="1lmwnmzc8ml75">
                    {policyLinks.map(link => <Link key={link.path} to={link.path} className={`block px-4 py-2 text-sm transition-colors ${location.pathname === link.path ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsPoliciesOpen(false)} data-id="element-267" data-mp="1go370y1nme2r">
                        {link.name}
                      </Link>)}
                  </div>
                </div>}
            </div>
          </div>
          {/* Mobile menu button */}
          <button onClick={toggleMenu} className="md:hidden bg-burgundy-600 text-white p-2 rounded-md" aria-label="Toggle menu" data-id="element-268" data-mp="2zkogqs6pod98">
            {isOpen ? <XIcon size={24} data-id="element-269" data-mp="34lktlv91j9qs" /> : <MenuIcon size={24} data-id="element-270" data-mp="39j45wpm6hcg3" />}
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden" data-id="element-271" data-mp="3eiywes21k00m">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-gray-200" data-id="element-272" data-mp="3eful7aq5s40g">
            <Link to="/" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-273" data-mp="osc3oend26c8">
              Home
            </Link>
            {/* Mobile Lessons Dropdown - Moved to appear after Home */}
            <div data-id="element-274" data-mp="lq8ivvg6tpw8">
              <button onClick={toggleLessonsMenu} className={`flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium ${lessonLinks.some(link => location.pathname === link.path) ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-275" data-mp="lrt61006a6k2">
                <span data-id="element-276" data-mp="2xxkoewhag4g">Our Lessons</span>
                {isLessonsOpen ? <ChevronUp size={16} data-id="element-277" data-mp="7yldn649p71b" /> : <ChevronDown size={16} data-id="element-278" data-mp="7vz8fd4un3m9" />}
              </button>
              {isLessonsOpen && <div className="pl-4 mt-1 space-y-1 border-l-2 border-gray-200 ml-3" data-id="element-279" data-mp="1jd8mfk57l3g6">
                  {lessonLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${location.pathname === link.path ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-280" data-mp="33u845jkqdxtx">
                      {link.name}
                    </Link>)}
                </div>}
            </div>
            {/* Total Drive App link - Moved to appear after Our Lessons */}
            <Link to="/total-drive" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/total-drive' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-281" data-mp="2b745dwc8efql">
              Total Drive App
            </Link>
            {/* Tips link */}
            <Link to="/tips" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/tips' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-282" data-mp="1yvkzu5c0okqt">
              Tips
            </Link>
            {/* FAQ link */}
            <Link to="/faq" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/faq' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-283" data-mp="2hmchdu65rhga">
              FAQ
            </Link>
            {/* Blogs link - NEW */}
            <Link to="/blogs" className={`flex items-center px-3 py-2 rounded-md text-base font-medium ${location.pathname.startsWith('/blog') ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-284" data-mp="x70p45x20sh5">
              <FileText size={16} className="mr-2" data-id="element-285" data-mp="oqi7gpfn77f0" />
              Blogs
            </Link>
            {/* About Us link */}
            <Link to="/about" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/about' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-286" data-mp="13ly677r63rhq">
              About Us
            </Link>
            {/* Contact Us link */}
            <Link to="/contact" className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === '/contact' ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsOpen(false)} data-id="element-287" data-mp="kon5rjtsus0p">
              Contact Us
            </Link>
            {/* Mobile Policies Dropdown - Moved to appear at the end */}
            <div data-id="element-288" data-mp="2mol7xrs9vnlk">
              <button onClick={togglePoliciesMenu} className={`flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium ${policyLinks.some(link => location.pathname === link.path) ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} data-id="element-289" data-mp="2mkxeesmtv16u">
                <span data-id="element-290" data-mp="35eb2qew1c9dh">Our Policies</span>
                {isPoliciesOpen ? <ChevronUp size={16} data-id="element-291" data-mp="3accjgt5znwls" /> : <ChevronDown size={16} data-id="element-292" data-mp="3aarrnbb26rrm" />}
              </button>
              {isPoliciesOpen && <div className="pl-4 mt-1 space-y-1 border-l-2 border-gray-200 ml-3" data-id="element-293" data-mp="3ecdcbitu4acd">
                  {policyLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${location.pathname === link.path ? 'bg-burgundy-600 text-white' : 'text-gray-700 hover:bg-burgundy-600 hover:text-white'}`} onClick={() => setIsPoliciesOpen(false)} data-id="element-294" data-mp="1k0yjgt5j1use">
                      {link.name}
                    </Link>)}
                </div>}
            </div>
          </div>
        </div>}
    </nav>;
};
export default Navbar;